/* Builds the article's table of contents from the headings in its body.

   The body is merchant-authored HTML pasted into the admin editor, so the
   headings arrive with no ids and the theme has no structured version of
   them to render from Liquid — the index has to be derived from the
   rendered document.

   The sidebar is markup-only until this runs and stays hidden until it has
   something to list, so an article with no headings shows no empty panel. */
(function () {
  var body = document.querySelector('[data-article-body]');
  var nav = document.querySelector('[data-article-toc]');
  var layout = document.querySelector('[data-article-layout]');
  var list = nav && nav.querySelector('[data-article-toc-list]');

  if (!body || !nav || !list) return;

  function slugify(text) {
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 60);
  }

  var headings = [];
  var used = {};

  body.querySelectorAll('h2, h3').forEach(function (heading) {
    var text = (heading.textContent || '').trim();
    if (!text) return;

    if (!heading.id) {
      var base = slugify(text) || 'section';
      var slug = base;
      var n = 1;

      // Two "Why buyers love it" headings in one article would otherwise
      // both answer to the same id, and every link would land on the first.
      while (used[slug] || document.getElementById(slug)) {
        n += 1;
        slug = base + '-' + n;
      }

      used[slug] = true;
      heading.id = slug;
    }

    headings.push(heading);
  });

  if (!headings.length) {
    nav.remove();
    if (layout) layout.classList.add('pb-article__layout--full');
    return;
  }

  var links = headings.map(function (heading) {
    var item = document.createElement('li');
    item.className = 'pb-toc__item pb-toc__item--' + heading.tagName.toLowerCase();

    var link = document.createElement('a');
    link.className = 'pb-toc__link';
    link.href = '#' + heading.id;
    link.textContent = (heading.textContent || '').trim();

    item.appendChild(link);
    list.appendChild(item);

    return { heading: heading, item: item, link: link };
  });

  nav.hidden = false;

  /* An FAQ question is a heading inside a collapsed accordion row. Jumping
     to it without opening the row would scroll to a closed panel and look
     like a dead link, so the row is opened first — through its own trigger,
     so the accordion script keeps ownership of the state. */
  function revealAccordion(heading) {
    var item = heading.closest('.pb-acc__item');
    if (!item || item.classList.contains('is-open')) return;

    var trigger = item.querySelector('.pb-acc__trigger');
    if (trigger) trigger.click();
  }

  links.forEach(function (entry) {
    entry.link.addEventListener('click', function () {
      revealAccordion(entry.heading);
    });
  });

  /* Highlights the heading currently at the top of the viewport. rootMargin
     shrinks the observed band to a strip just below the sticky header, so
     exactly one heading — the one being read — is intersecting at a time. */
  if (!('IntersectionObserver' in window)) return;

  var visible = [];

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var index = visible.indexOf(entry.target);

        if (entry.isIntersecting && index === -1) visible.push(entry.target);
        if (!entry.isIntersecting && index !== -1) visible.splice(index, 1);
      });

      if (!visible.length) return;

      var first = headings.filter(function (heading) {
        return visible.indexOf(heading) !== -1;
      })[0];

      links.forEach(function (entry) {
        entry.item.classList.toggle('is-current', entry.heading === first);
      });
    },
    { rootMargin: '-100px 0px -70% 0px' }
  );

  headings.forEach(function (heading) {
    observer.observe(heading);
  });
})();
